import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { resolvePostAuthRedirect } from "@/lib/auth";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallbackPage,
});

/** Return URL for email confirmation and Google sign-in. */
function AuthCallbackPage() {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Give the client a moment to exchange the code / read the URL hash.
        for (let i = 0; i < 20; i++) {
          const { data } = await supabase.auth.getSession();
          if (data.session) break;
          await new Promise((r) => setTimeout(r, 100));
        }
        const { data } = await supabase.auth.getSession();
        if (!data.session) {
          if (!cancelled) setFailed(true);
          return;
        }
        window.history.replaceState({}, "", window.location.pathname);
        const dest = await resolvePostAuthRedirect();
        if (!cancelled) navigate({ to: dest, replace: true });
      } catch (err) {
        console.error("[auth/callback]", err);
        if (!cancelled) setFailed(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="grid min-h-svh place-items-center bg-a1-black px-4 text-center text-sm text-white/70">
      {failed ? (
        <div className="space-y-3">
          <p>We couldn't complete sign-in. The link may have expired.</p>
          <Link to="/login" className="font-semibold text-white underline decoration-a1-red underline-offset-4">
            Back to sign in
          </Link>
        </div>
      ) : (
        <p>Signing you in…</p>
      )}
    </div>
  );
}
